module.exports = __webpack_public_path__ + "static/index/img/auto_background.f12e0131.jpg";